const YOUTUBE_MEDIA_ID = 1
const VIMEO_MEDIA_ID = 2
const SQL_DATETIME_PATTERN = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/

const isValidDateTimePart = (match) => {
  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const hour = Number(match[4])
  const minute = Number(match[5])
  const second = Number(match[6])

  if (
    year < 1000 ||
    month < 1 ||
    month > 12 ||
    hour > 23 ||
    minute > 59 ||
    second > 59
  ) {
    return false
  }

  const daysInMonth = new Date(Date.UTC(year, month, 0)).getUTCDate()
  return day >= 1 && day <= daysInMonth
}

const toTokyoDateTime = (value) => {
  if (typeof value !== "string") return null

  const match = value.match(SQL_DATETIME_PATTERN)
  if (!match || !isValidDateTimePart(match)) {
    return null
  }

  return `${value.replace(" ", "T")}+09:00`
}

// YouTube は配信元の公開日時、Vimeo は動画のサイトマップと同じ「NobodySurf に載せた日時」（仕様 0023）
const normalizeUploadDate = ({ uploadDate, publicationDate, movieMediaId }) => {
  if (movieMediaId === YOUTUBE_MEDIA_ID) return toTokyoDateTime(uploadDate)
  if (movieMediaId === VIMEO_MEDIA_ID) return toTokyoDateTime(publicationDate)
  return null
}

const isNonEmptyString = (value) =>
  typeof value === "string" && value.trim().length > 0

const isHttpUrl = (value) =>
  isNonEmptyString(value) && /^https?:\/\/\S+$/i.test(value)

const buildVideoObject = ({
  title,
  description,
  images,
  uploadDate,
  publicationDate,
  movieMediaId,
  duration,
  embedUrl,
  publisher,
}) => {
  const normalizedUploadDate = normalizeUploadDate({
    uploadDate,
    publicationDate,
    movieMediaId,
  })
  const thumbnailUrl = Array.isArray(images) ? images.filter(isHttpUrl) : []

  if (
    !isNonEmptyString(title) ||
    thumbnailUrl.length === 0 ||
    normalizedUploadDate === null
  ) {
    return null
  }

  const video = {
    ["@context"]: "https://schema.org",
    ["@type"]: "VideoObject",
    name: title,
    thumbnailUrl,
    uploadDate: normalizedUploadDate,
    publisher,
  }

  if (isNonEmptyString(description)) {
    video.description = description
  }
  if (isNonEmptyString(duration)) {
    video.duration = duration
  }
  if (isHttpUrl(embedUrl)) {
    video.embedUrl = embedUrl
  }

  return video
}

module.exports = {
  buildVideoObject,
  normalizeUploadDate,
}
